import {
  ErrorType,
  LoadedType,
  RequestType,
  type UpsertOnboardingAction,
  UpsertType,
} from 'common/actions/onboarding';
import requestReducerFactory, {
  type RequestState,
  defaultState,
} from 'common/reducers/requestReducerFactory';

import type { Onboarding } from 'common/api/endpoints/onboarding';

const baseReducer = requestReducerFactory<Onboarding>(RequestType, LoadedType, ErrorType);

export default function onboarding(
  state: RequestState<Onboarding> = defaultState,
  action: Action | UpsertOnboardingAction,
): RequestState<Onboarding> {
  switch (action.type) {
    case UpsertType: {
      const setAction = action as UpsertOnboardingAction;
      return {
        ...state,
        data: setAction.data,
        lastUpdated: (action as any).timestamp ?? state.lastUpdated,
      };
    }

    default:
      return baseReducer(state, action as Action);
  }
}
